/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default [
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: true
    }, 
    url: '/dashboard/students',
    name: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    slug: 'dashboard-students'
    /* tag: '2',
    tagColor: 'warning',
    submenu: [
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,          
          caissier: true,
          saisisseur: true,
          saisisseurexterne: true
        },
        url: '/dashboard/students',
        name: 'Students',
        slug: 'dashboard-students',
        i18n: 'Students'
      }
    ] */
  },
  {
    roles: {
      directeur: false,
      admin: true,
      comptable: false,
      saisisseur: false
    },
    url: null,
    name: 'SMS Messaging',
    icon: 'MessageSquareIcon',
    i18n: 'SMS_Messaging',
    submenu: [
      {
        roles: {
          directeur: false,
          admin: true,
          comptable: false,
          saisisseur: false
        },
        url: '/SMS_Messaging/Personalize',
        name: 'Personalize',
        slug: 'SMS_Messaging-Personalize',
        i18n: 'Personalize'
      }
    ]
  },
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: true
    },
    url: null,
    name: 'Student management',
    icon: 'UsersIcon',
    i18n: 'Student_management',
    submenu: [
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/Student_management/Student/main/0',
        name: 'Student',
        slug: 'Student_management-Student',
        i18n: 'Student'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/Student_management/change/room',
        name: 'Change class',
        slug: 'Student_management-change-room',
        i18n: 'Change_class'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/Student_management/Abandonment',
        name: 'Abandonment',
        slug: 'Student_management-Abandonment',
        i18n: 'Abandonment'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/Student_management/Parent',
        name: 'Parent',
        slug: 'Student_management-Parent',
        i18n: 'Parent'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/Student_management/Attendance/main/0',
        name: 'Attendance',
        slug: 'Student_management-Attendance',
        i18n: 'Attendance'
      }
    ]
  },
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: false
    },
    url: null,
    name: 'Accounting management',
    icon: 'DollarSignIcon',
    i18n: 'accounting_management',
    submenu: [
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/accounting_management/type_of_fees',
        name: 'Type of fees',
        slug: 'accounting_management-type_of_fees',
        i18n: 'type_of_fees'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/accounting_management/school_fees',
        name: 'Add payment of school fees',
        slug: 'accounting_management-school_fees',
        i18n: 'school_fees'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/accounting_management/payments_state',
        name: 'State of payments',
        slug: 'accounting_management-payments_state',
        i18n: 'State_of_payments'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/accounting_management/etatFinancier',
        name: 'État Financier',
        slug: 'accounting_management-etatFinancier',
        i18n: 'etat_financier'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/accounting_management/receipts',
        name: 'Receipts',
        slug: 'accounting_management-receipts',
        i18n: 'Receipts'
      }
    ]
  },
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: true
    },
    url: null,
    name: 'Class management',
    icon: 'LayersIcon',
    i18n: 'class_management',
    submenu: [
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/class_management/class',
        name: 'Class',
        slug: 'class_management-class',
        i18n: 'class'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/class_management/room',
        name: 'Room',
        slug: 'class_management-room',
        i18n: 'room'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/class_management/serie',
        name: 'Serie',
        slug: 'class_management-serie',
        i18n: 'serie'
      }
    ]
  },
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: true
    },
    url: null,
    name: 'Report cards management',
    icon: 'BookOpenIcon',
    i18n: 'report_cards_management',
    submenu: [
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/report_cards_management/exam',
        name: 'Exam',
        slug: 'report_cards_management-exam',
        i18n: 'exam'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/report_cards_management/report_card',
        name: 'Report card',
        slug: 'report_cards_management-report_card',
        i18n: 'report_card'
      },
      // paramettre debut
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: null,
        name: 'Settings',
        i18n: 'settings',
        submenu: [
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/student_by_partition',
            name: 'Student by partition',
            slug: 'report_cards_management-student_by_partition',
            i18n: 'student_by_partition'
          },
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/Dispense_from_a_matter',
            name: 'Dispense from a matter',
            slug: 'report_cards_management-Dispense_from_a_matter',
            i18n: 'Dispense_from_a_matter'
          },
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/matter_by_teachers',
            name: 'Matter by teachers',
            slug: 'report_cards_management-matter_by_teachers',
            i18n: 'matter_by_teachers'
          },
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/matter_by_class',
            name: 'Matter by class',
            slug: 'report_cards_management-matter_by_class',
            i18n: 'matter_by_class'
          },
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/full_professor_per_room',
            name: 'Full professor per room',
            slug: 'report_cards_management-full_professor_per_room',
            i18n: 'Full_professor_per_room'
          },
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/matter',
            name: 'Matter',
            slug: 'report_cards_management-matter',
            i18n: 'matter'
          },
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/matter_type',
            name: 'Matter type',
            slug: 'report_cards_management-matter_type',
            i18n: 'matter_type'
          },
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/exam_type',
            name: 'Exam type',
            slug: 'report_cards_management-exam_type',
            i18n: 'exam_type'
          },
          {
            roles: {
              directeur: true,
              admin: true,
              comptable: true,
              saisisseur: true
            },
            url: '/report_cards_management/appreciation',
            name: 'Exam type',
            slug: 'report_cards_management-appreciation',
            i18n: 'appreciation'
          }
        ]
      }
      // paramettre fin
    ]
  },
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: true
    },
    url: null,
    name: 'Employee management',
    icon: 'UsersIcon',
    i18n: 'Employee_management',
    submenu: [
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/Employee_management/Employee',
        name: 'Employee',
        slug: 'Employee_management-Employee',
        i18n: 'Employee'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/Employee_management/Post',
        name: 'Post',
        slug: 'Employee_management-Post',
        i18n: 'Post'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/Employee_management/Marital_status',
        name: 'Marital status',
        slug: 'Employee_management-Marital_status',
        i18n: 'Marital_status'
      }
    ]
  },
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: false
    },
    url: null,
    name: 'Salary management',
    icon: 'DollarSignIcon',
    i18n: 'Salary_management',
    submenu: [
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/salary_management/Employee_to_pay',
        name: 'Employee to pay',
        slug: 'salary_management-Employee_to_pay',
        i18n: 'Employee_to_pay'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/salary_management/Premiums',
        name: 'Premiums',
        slug: 'salary_management-Premiums',
        i18n: 'Premiums'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/salary_management/Banks',
        name: 'Banks',
        slug: 'salary_management-Banks',
        i18n: 'Banks'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: false
        },
        url: '/salary_management/Month',
        name: 'Month',
        slug: 'salary_management-Month',
        i18n: 'Month'
      }
    ]
  },
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: true
    },
    url: null,
    name: 'Year opening management',
    icon: 'CalendarIcon',
    i18n: 'year_opening_management',
    submenu: [
      {
        roles: {
          directeur: false,
          admin: true,
          comptable: false,
          saisisseur: false
        },
        url: '/year_opening_management/Pre_end_of_the_year',
        name: 'Pre-end of the year',
        slug: 'year_opening_management-Pre_end_of_the_year',
        i18n: 'Pre_end_of_the_year'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/year_opening_management/school_years',
        name: 'School years',
        slug: 'year_opening_management-school_years',
        i18n: 'school_years'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/year_opening_management/partitions',
        name: 'Partitions',
        slug: 'year_opening_management-partitions',
        i18n: 'partitions'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/year_opening_management/types_of_partitions',
        name: 'Types of partitions',
        slug: 'year_opening_management-types_of_partitions',
        i18n: 'types_of_partitions'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/year_opening_management/levels',
        name: 'Levels',
        slug: 'year_opening_management-levels',
        i18n: 'levels'
      },
      {
        roles: {
          directeur: false,
          admin: true,
          comptable: false,
          saisisseur: false
        },
        url: '/year_opening_management/years',
        name: 'Years',
        slug: 'year_opening_management-years',
        i18n: 'Years'
      }
    ]
  },
  {
    roles: {
      directeur: true,
      admin: true,
      comptable: true,
      saisisseur: true
    },
    url: null,
    name: 'Settings',
    icon: 'SettingsIcon',
    i18n: 'settings',
    submenu: [
      {
        roles: {
          directeur: false,
          admin: true,
          comptable: false,
          saisisseur: false
        },
        url: '/management/users',
        name: 'Users',
        slug: 'management-users',
        i18n: 'users'
      },
      {
        roles: {
          directeur: true,
          admin: true,
          comptable: true,
          saisisseur: true
        },
        url: '/management/school',
        name: 'School',
        slug: 'management-school',
        i18n: 'school'
      },
      {
        roles: {
          directeur: false,
          admin: true,
          comptable: false,
          saisisseur: false
        },
        url: '/management/role/roles',
        name: 'Roles',
        slug: 'management-role-roles',
        i18n: 'roles'
      },
      {
        roles: {
          directeur: false,
          admin: true,
          comptable: false,
          saisisseur: false
        },
        url: '/management/sex',
        name: 'Sex',
        slug: 'management-sex',
        i18n: 'sex'
      },
      {
        roles: {
          directeur: false,
          admin: true,
          comptable: false,
          saisisseur: false
        },
        url: '/management/Student_status',
        name: 'Student status',
        slug: 'management-Student_status',
        i18n: 'Student_status'
      }
    ]
  }
]